<template>
  <path
    d="M31.6579 64C49.1416 64 63.316 49.7008 63.316 32C63.316 14.2992 49.1416 0 31.6579 0C14.1741 0 -0.000244141 14.2992 -0.000244141 32C-0.000244141 49.7008 14.1741 64 31.6579 64Z"
    fill="#343E61"
  />
  <path
    d="M8.36692 11.2756H53.3876C55.1984 11.2756 56.5721 12.6614 56.5721 14.4882V43.2756C56.5721 45.1024 55.1984 46.4882 53.3876 46.4882H8.36692C6.5561 46.4882 5.18237 45.1024 5.18237 43.2756V14.4882C5.18237 12.6614 6.68098 11.2756 8.36692 11.2756Z"
    fill="#4F5C87"
  />
  <path
    d="M57.4467 29.7322V43.9055C57.4467 45.7322 56.0106 47.244 54.1373 47.244H7.86778C6.05696 47.244 4.55835 45.7322 4.55835 43.9055V28.5354"
    stroke="#1676EE"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M53.513 21.7952H38.9015C37.4654 21.7952 36.0917 22.2992 35.0301 23.181L31.2212 26.3307C30.1597 27.2125 28.7859 27.7165 27.3498 27.7165H10.8651C9.17914 27.7165 7.80542 29.1023 7.80542 30.8031C7.80542 30.9291 7.80542 31.1181 7.86786 31.244L10.9275 47.496C11.1773 49.0078 12.4261 50.1417 13.9872 50.1417H49.2669C50.7655 50.1417 52.0768 49.0708 52.3266 47.559L56.5726 25.3228C56.8848 23.622 55.7609 22.1102 54.075 21.7952C53.8252 21.7952 53.6379 21.7952 53.513 21.7952Z"
    fill="#9FA4A8"
  />
  <path
    d="M60.0695 17.4488H41.0871C39.2139 17.4488 37.4655 18.0787 36.0293 19.2755L31.034 23.37C29.6602 24.5039 27.8494 25.1968 25.9762 25.1968H4.4961C2.31063 25.1968 0.562256 27.0236 0.562256 29.1653C0.562256 29.3543 0.562256 29.5433 0.624698 29.7322L4.55854 50.9606C4.87076 52.9763 6.55669 54.4252 8.49239 54.4252H54.4497C56.4479 54.4252 58.0714 53.0393 58.3836 51.0236L63.9409 21.9842C64.3156 19.7795 62.8794 17.8267 60.6939 17.3858C60.5066 17.4488 60.2568 17.4488 60.0695 17.4488Z"
    fill="#68759C"
  />
  <path
    d="M23.3533 39.4333C24.4773 39.4333 25.4139 38.4884 25.4139 37.3545C25.4139 36.2207 24.4773 35.2758 23.3533 35.2758C22.2294 35.2758 21.2927 36.2207 21.2927 37.3545C21.2927 38.4884 22.2294 39.4333 23.3533 39.4333Z"
    fill="#FAFAFB"
  />
  <path
    d="M39.4012 39.3701C40.5251 39.3701 41.4618 38.4252 41.4618 37.2914C41.4618 36.1575 40.5251 35.2126 39.4012 35.2126C38.2772 35.2126 37.3406 36.1575 37.3406 37.2914C37.3406 38.4882 38.2772 39.3701 39.4012 39.3701Z"
    fill="#FAFAFB"
  />
  <path d="M33.3438 41.6377H29.4724V42.5826H33.3438V41.6377Z" fill="#FAFAFB" />
</template>

